import { createComponent } from '@carvana/merch-components';

export const HeroFavoriteAndSearchCard = createComponent('div', {
  className:
    'h-fit rounded-md border border-solid border-grey-2 bg-white m:h-[448px]'
});

export const HeroFinanceCard = createComponent('div', {
  className:
    'grid h-[184px] gap-16 rounded-md border-[1px] border-solid border-grey-2 bg-white p-24 m:h-[216px] m:gap-24 l:h-[211px]'
});
